export const ADD_MENU_POPOVER_TEST_ID = 'add-menu-popover';

export const AUDIO_CONTROL_POPOVER_TEST_ID = 'audio-control-popover';
